// @flow
import * as React from 'react';

import { useAddress } from '@gandi/react-places';
import type { FavoriteContact } from '@gandi/redux-resource-contactbook';
import { useTranslator } from '@gandi/translate';
import { Base, Text } from '@gandi/ui';

import { getDisplayedType, getDisplayName } from '../../../../modules/helpers';

export type Props = {
  contact: FavoriteContact,
};

const ContactDetails = ({ contact }: Props) => {
  const translator = useTranslator();

  const { address } = useAddress({
    data: contact,
    showRecipient: true,
  });

  return (
    <Base padding="small">
      <Base tagName="p" margin="none">
        <Base tagName="span" flex flexAlignItemsCenter weight="semibold">
          {getDisplayName(contact)}
        </Base>
        <Text color="light">{getDisplayedType(translator, contact.type)}</Text>
        <br />
        {contact.email}
        <br />
        {address}
        {contact.phone && (
          <>
            <br />
            {contact.phone}
          </>
        )}
      </Base>
    </Base>
  );
};

export default (React.memo<Props>(ContactDetails): React.ComponentType<Props>);
